import ExpertsSlider from "./components/experts-slider"
import {use} from "i18next"
import {initReactI18next} from "react-i18next"
import CommonUtils from "@bodeboca/utils"
import SearchApp from "@bodeboca/algolia/apps/search/search_app"

use(initReactI18next)
  .init(CommonUtils.i18NConfig())
  .then(() => {
    // Loaded
  })
const App = () => {
  return (<>
    <ExpertsSlider/>
    <SearchApp/>
  </>)
}
export default App
